import { render, staticRenderFns } from "./classinfoadd.vue?vue&type=template&id=598b354e&scoped=true"
import script from "./classinfoadd.vue?vue&type=script&lang=js"
export * from "./classinfoadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598b354e",
  null
  
)

export default component.exports